import { Routes } from '@angular/router';

import { authGuard } from './core/guards/auth.guard';
import { loginGuard } from './core/guards/login.guard';
import { forgotPasswordGuard } from './core/guards/forgot-password.guard';
import { canDeactivateGuard } from './core/guards/can-deactivate.guard';
import { dataGuard } from './core/guards/data.guard';
import { lookupGuard } from './core/guards/lookups.guard';

export const routes: Routes = [
    {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
    },
    {
        path: 'login',
        canActivate: [loginGuard],
        loadComponent: () => import('./pages/login/login.component').then(c => c.LoginComponent),
        title: 'SAL Training Modules - Login',
    },
    {
        path: 'forgot-password',
        canActivate: [forgotPasswordGuard],
        loadComponent: () => import('./pages/forgot-password/forgot-password.component').then(c => c.ForgotPasswordComponent),
        title: 'SAL Training Modules - Forgot Password',
    },
    {
        path: 'verify-reset-request/:id',
        canActivate: [forgotPasswordGuard],
        loadComponent: () => import('./pages/verify-reset-request/verify-reset-request.component').then(c => c.VerifyResetRequestComponent),
    },
    {
        path: 'dashboard',
        canActivate: [authGuard, dataGuard, lookupGuard],
        loadComponent: () => import('./pages/dashboard/dashboard.component').then(c => c.DashboardComponent),
        title: 'SAL Training Modules - Dashboard',
    },
    {
        path: 'survey/:id',
        canActivate: [authGuard, dataGuard, lookupGuard],
        canDeactivate: [canDeactivateGuard],
        loadComponent: () => import('./pages/survey/survey.component').then(c => c.SurveyComponent),
        title: 'SAL Training Modules - Survey',
        children: [
            {
                path: ':page',
                loadComponent: () => import('./pages/survey/survey-questions/survey-questions.component').then(c => c.SurveyQuestionsComponent),
            }
        ]
    },
    {
        path: '**',
        redirectTo: '/'
    },
];
